import { BLACK, CRIMSON_500, NEUTRAL_100, PRIMARY } from '../../styles/colors';
import { GIVONIC } from '../../styles/fonts';
import styled, { css } from 'styled-components';

interface ButtonContainerProps {
  $fullWidth?: boolean;
  disabled?: boolean;
  $variant?: 'primary' | 'outline' | 'danger' | 'outline-black';
}

export const ButtonContainer = (styled.button as any)<ButtonContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  border-radius: 8px;
  border: none;
  height: 6vh;
  min-height: 38px;
  font-family: ${GIVONIC.semiBold};
  letter-spacing: 1px;
  font-size: 14px;
  text-transform: uppercase;
  transition: background-color 0.2s ease;
  cursor: ${({ disabled }: ButtonContainerProps) => (disabled ? 'not-allowed' : 'pointer')};
  width: ${({ $fullWidth }: ButtonContainerProps) => ($fullWidth ? '100%' : 'auto')};

  /* Apply the vertical offset correction */
  & > span {
    display: inline-block;
    position: relative;
    top: 2px; /* Move text down by specified pixels */
  }

  ${({ $variant, disabled }: ButtonContainerProps) => {
    switch ($variant) {
      case 'outline':
        return css`
          background-color: transparent;
          border: 1px solid ${PRIMARY};
          color: ${PRIMARY};

          &:hover {
            background-color: rgba(106, 13, 173, 0.05);
          }

          &:active {
            background-color: rgba(106, 13, 173, 0.1);
          }
        `;
      case 'outline-black':
        return css`
          background-color: transparent;
          border: 1px solid ${BLACK};
          color: ${BLACK};

          &:hover {
            background-color: rgba(106, 13, 173, 0.05);
          }

          &:active {
            background-color: rgba(106, 13, 173, 0.1);
          }
        `;
      case 'danger':
        return css`
          background-color: transparent;
          border: 1.5px solid ${CRIMSON_500};
          color: ${CRIMSON_500};

          &:hover {
            background-color: rgba(106, 13, 173, 0.05);
          }

          &:active {
            background-color: rgba(106, 13, 173, 0.1);
          }
        `;
      case 'primary':
      default:
        return css`
          /* Purple button when enabled */
          background-color: ${disabled ? NEUTRAL_100 : PRIMARY};
          color: ${disabled ? '#9CA3AF' : 'white'};

          &:hover {
            background-color: ${disabled ? NEUTRAL_100 : PRIMARY};
          }

          &:active {
            background-color: ${disabled ? NEUTRAL_100 : PRIMARY};
          }
        `;
    }
  }}

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(106, 13, 173, 0.3);
  }
`;
